'use strict';

var north = gettext('N'),
    ne    = gettext('NE'),
    east  = gettext('E'),
    se    = gettext('SE'),
    south = gettext('S'),
    sw    = gettext('SW'),
    west  = gettext('W'),
    nw    = gettext('NW');


module.exports = function degree2String ( degree ) {
    if ( degree < 22.5 ) {
        return north;
    }
    if ( degree < 67.5 ) {
        return ne;
    }
    if ( degree < 112.5 ) {
        return east;
    }
    if ( degree < 157.5 ) {
        return se;
    }
    if ( degree < 202.5 ) {
        return south;
    }
    if ( degree < 247.5 ) {
        return sw;
    }
    if ( degree < 292.5 ) {
        return west;
    }
    if ( degree < 337.5 ) {
        return nw;
    }

    return north;
};
